import { useCallback, useEffect, useRef } from 'react'

/**
 * Encapsulates AbortController lifecycle for sequential async operations.
 *
 * getSignal() — cancels any in-flight request and returns a fresh AbortSignal
 *               for the next one.
 * On unmount the current in-flight request is automatically canceled.
 */
const useAbortController = () => {
    const controllerRef = useRef(null)

    useEffect(() => {
        return () => {
            controllerRef.current?.abort()
        }
    }, [])

    const getSignal = useCallback(() => {
        controllerRef.current?.abort()
        const controller = new AbortController()
        controllerRef.current = controller
        return controller.signal
    }, [])

    return { getSignal }
}

export { useAbortController }

